export const deployInfo = {
  shortSha: 'a99190f',
  commitSha: 'a99190fcd7a5b8c4f040dcc89a3f73f3767be0da',
  rollbar: { webPostToken: '0ba6e92852d34daca1cfa9d0ca291a82' }
}
